<ion-header class="ion-no-border">
  <ion-toolbar class="ion-padding">
    <ion-title>{{ 'app#core##select_language' | translate }}</ion-title> <!-- Using existing key or new one -->
    <ion-buttons slot="end">
      <ion-button size="large" color="secondary" (click)="close()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-list [inset]="true">
    @for (lang of languageService.supportedLanguages(); track lang) {
      <ion-item lines="inset" (click)="selectLanguage(lang)">
        <div class="list-item-content" style="display: flex; align-items: center; width: 100%;">
          <div class="list-item-content__flag" style="font-size: 1.5em; margin-right: 10px;">
            <ng-icon [name]="getFlagName(lang)" size="24"></ng-icon>
          </div>
          <div class="list-item-content__title" style="flex: 1; font-weight: 500;">
            {{ getLanguageName(lang) }}
          </div>

          @if (lang === languageService.currentLang()) {
            <ion-icon name="checkmark" color="dark" size="large"></ion-icon>
          }
        </div>
      </ion-item>
    }
  </ion-list>
</ion-content>
